import * as Yup from "yup";
import { EMAIL_VALIDATION_ERRROR, FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const forgotInitialValues = {
  email: ""
}

export const forgotValidationSchema = Yup.object({
  email: Yup.string().email(EMAIL_VALIDATION_ERRROR).required(FIELD_REQUIRED_MESSAGE),
});
